module.exports = __webpack_public_path__ + "img/image_ot-peru-andina-services_marine-platform1_1920px.4f49d12b.jpg";